import {
  AmplitudeContext,
  AmplitudeEventConstants,
} from '@homebot/shared-util-quartermaster'
import { useSelector } from 'react-redux'
import { useContext, useEffect } from 'react'
import { PmiStatus } from '../../../../../types/pmi'
import { NOT_YET, SOON, NOW } from '../pmiConstants'
import { defineMessages, useIntl } from 'react-intl'
import { Text } from '@homebot/shared-ui-swashbuckle'
import { RootState } from '../../../../../types/rootState'
import { useAmplitudeDebounceSetters } from '../../../../../hooks/tracking'

export const MSG = defineMessages({
  notYet: {
    id: 'PMI.timelineForRemoval.notYet',
    defaultMessage: 'Not yet',
  },
  maybeNow: {
    id: 'PMI.timelineForRemoval.maybeNow',
    defaultMessage: 'Maybe now',
  },
  soon: {
    id: 'PMI.timelineForRemoval.soon',
    defaultMessage: 'Soon',
  },
})

export const TimelineForRemovalRainbowText = () => {
  const intl = useIntl()
  const { ampli } = useContext(AmplitudeContext)
  const pmiStatus = useSelector<RootState, PmiStatus>(state => state.pmi.status)
  const [trackPmiStatusNow] = useAmplitudeDebounceSetters(() => {
    ampli?.pmiIndicated({
      pmi_status: AmplitudeEventConstants.PMI_INDICATED_NOW,
    })
  })
  const [trackPmiStatusSoon] = useAmplitudeDebounceSetters(() => {
    ampli?.pmiIndicated({
      pmi_status: AmplitudeEventConstants.PMI_INDICATED_SOON,
    })
  })
  const [trackPmiStatusNotYet] = useAmplitudeDebounceSetters(() => {
    ampli?.pmiIndicated({
      pmi_status: AmplitudeEventConstants.PMI_INDICATED_NOT_YET,
    })
  })

  useEffect(() => {
    pmiStatus === NOW && trackPmiStatusNow()
    pmiStatus === SOON && trackPmiStatusSoon()
    pmiStatus === NOT_YET && trackPmiStatusNotYet()
  }, [pmiStatus, trackPmiStatusNow, trackPmiStatusSoon, trackPmiStatusNotYet])

  return (
    <Text
      size='2xl'
      textAlign='center'
      fontWeight='light'
      color={
        pmiStatus === NOT_YET
          ? 'danger'
          : pmiStatus === SOON
          ? 'warning'
          : 'success'
      }
    >
      {pmiStatus === NOT_YET && intl.formatMessage(MSG.notYet)}
      {pmiStatus === SOON && intl.formatMessage(MSG.soon)}
      {pmiStatus === NOW && intl.formatMessage(MSG.maybeNow)}
    </Text>
  )
}
